var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"Loader","appear":""}},[_c('div',{staticClass:"Loader"},[_c('div',{staticClass:"Loader__spin"})])])}
var staticRenderFns = []

export { render, staticRenderFns }